module.exports = __webpack_public_path__ + "img/AUB.6c4bd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mbbs_fair/AUB.png
// module id = 2000
// module chunks = 1